var p = Object.prototype;
function e(t) {
  var o = t && t.constructor, r = typeof o == "function" && o.prototype || p;
  return t === r;
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_isPrototype.js
// module id = 466
// module chunks = 67